import { isNil } from 'lodash'

export default {
    computed: {
        companyUrl() {
            return !isNil(this.company) && !isNil(this.company.ToUrl) ? encodeURI(this.company.ToUrl) : '#'
        }
    }
}